module.exports = __webpack_public_path__ + "static/img/top2.b5bf6c4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/top2.jpg
// module id = H4Im
// module chunks = 0